// File: ./CustomComponents/MemoizedComponents.jsx

import { memo } from 'react';
import GeneralLeaseInformation from './cardSections/GeneralLeaseInformation';
import FinancialTermsConditions from './cardSections/FinancialTermsConditions';
import AccountingInformation from './cardSections/AccountingInformation';
import IFRS16FieldsModifications from './cardSections/IFRS16FieldsModifications';
import ActionButtons from './cardSections/ActionButtons';
import LeaseTable from '../leaseRecordTable';

// Memoize each component to prevent unnecessary re-renders
export const MemoizedGeneralLeaseInformation = memo(GeneralLeaseInformation, (prevProps, nextProps) => {
	// Only re-render when screen or statusData changes
	return prevProps.screen === nextProps.screen && prevProps.statusData === nextProps.statusData;
});

export const MemoizedFinancialTermsConditions = memo(FinancialTermsConditions, (prevProps, nextProps) => {
	// Only re-render when screen, LeaseEndDate changes, or form changes
	return prevProps.screen === nextProps.screen && prevProps.LeaseEndDate === nextProps.LeaseEndDate;
});

export const MemoizedAccountingInformation = memo(AccountingInformation);

export const MemoizedIFRS16FieldsModifications = memo(IFRS16FieldsModifications, (prevProps, nextProps) => {
	// Deep compare the changes array to prevent unnecessary re-renders
	return prevProps.screen === nextProps.screen && prevProps.rowIndex === nextProps.rowIndex;
});

export const MemoizedActionButtons = memo(ActionButtons);

export const MemoizedLeaseTable = memo(LeaseTable, (prevProps, nextProps) => {
	// Only re-render when leaseResponseData changes
	return JSON.stringify(prevProps.leaseResponseData) === JSON.stringify(nextProps.leaseResponseData);
});
